import { isPreVerification } from '../flow-settings/settingsSelectors';
import { setExperimentUtk } from '../store/experiments/action-creators';
import { ExperimentActionTypes } from '../store/experiments/action-types';
import { getPreAccountCreatedExperimentIdentifier } from '../store/experiments/selectors';
import { ExperimentIdentifier } from './ExperimentIdentifier';
import { getExperimentIdentifierPhase, getExperimentsToFetch, getPortalExperiments } from './ExperimentUtils';
import { getUserExperimentIdentifier } from './getUserExperimentIdentifier';
import { getPortalIdTreatmentsClient, getTreatmentsClient } from './treatmentsClient';
import { setNextStep } from '../flow-management/setNextStep';
import { BIAB001RemoveSteps } from './biab001/biab001RemoveSteps';
import { getAllUtkExperiments } from './getUtkExperiments';
export const handleBulkTreatmentsSuccess = (response, dispatch, getState) => {
  const identifierPhase = getExperimentIdentifierPhase(getState());
  dispatch({
    type: ExperimentActionTypes.BulkUpdateExperiments,
    response,
    identifierPhase
  });

  if (identifierPhase === ExperimentIdentifier.PortalId && BIAB001RemoveSteps.stateCheck(getState(), dispatch)) {
    dispatch(setNextStep({
      rebuilder: BIAB001RemoveSteps.rebuildFlow
    }));
  }

  return dispatch({
    type: ExperimentActionTypes.ExperimentsFetched,
    identifierPhase
  });
};
export const makeBulkTreatmentsRequest = (state, dispatch, action) => {
  if (action.type !== ExperimentActionTypes.FetchExperiments) {
    return Promise.resolve();
  }

  const experiments = getExperimentsToFetch({
    identifierPhase: action.identifierPhase
  });

  if (experiments.length === 0) {
    return Promise.resolve({});
  }

  if (action.identifierPhase === ExperimentIdentifier.PortalId) {
    const portalIDClient = getPortalIdTreatmentsClient(state);
    return new Promise(resolve => portalIDClient.resolveExposures(getPortalExperiments(), resolve));
  }

  if (isPreVerification()) {
    dispatch(setExperimentUtk(getUserExperimentIdentifier()));
  }

  const utkExperiments = getAllUtkExperiments();
  return new Promise(resolve => getTreatmentsClient({
    identifier: getPreAccountCreatedExperimentIdentifier(state)
  }).resolveExposures(utkExperiments, resolve));
};